export const defaultProviderAddresses = {
    crossChain: '0x0000000000000000000000000000000000000000',
    onChain: '0x9dd6562f51510696e66C63108Ec0f11c3c4f6571'
};
